import { booleanAttribute, ChangeDetectionStrategy, Component, Input, OnInit, signal } from '@angular/core';
import { IconComponent } from '@shared/ui-components/icon/icon.component';
import { animate, state, style, transition, trigger } from '@angular/animations';

export const accordBodyAnimation = trigger('accordBodyAnimation', [
  state('collapsed, void', style({ height: '0px', visibility: 'hidden', padding: '0px 24px' })),
  state('expanded', style({ height: '*', visibility: '', padding: '*' })),
  transition('expanded <=> collapsed, void => collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
]);
export const accordIndicatorAnimation = trigger('accordIndicatorAnimation', [
  state('collapsed, void', style({ transform: 'rotate(0deg)' })),
  state('expanded', style({ transform: 'rotate(180deg)' })),
  transition('expanded <=> collapsed, void => collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
]);

@Component({
  selector: 'ac-accordion',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  animations: [accordBodyAnimation, accordIndicatorAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent implements OnInit {
  @Input({ transform: booleanAttribute }) expandable = false;
  @Input({ transform: booleanAttribute }) sideNav?: boolean | string;
  @Input() initial: 'expanded' | 'collapsed' = 'expanded';
  protected readonly _expanded = signal(true);

  public ngOnInit(): void {
    if (this.expandable && this.initial === 'collapsed') {
      this._expanded.set(false);
    }
  }
  public toggle(): void {
    this._expanded.set(!this._expanded());
  }
}
